module.exports = __webpack_public_path__ + "media/images/help/post-template-f587305a06536e023bc5216c82b11c96.png";